import React, { FC, useEffect, useRef, useState } from 'react'
import { LocaleCodes } from '../../../constants/localization.constants'
import { MenuNav } from '../../../models/others/menuNav'
import { IconLinksSection, Navbar, NavbarContainer } from './style'
import { ButterBar } from './subcomponents/butterBar'
import { NavLinks } from './subcomponents/navLinks'
import { NavButton, NavHamburgerIcon, NavLogo, TopHatLinks } from './subcomponents/navParts'
import { SearchIcon } from './subcomponents/searchIcon'

type Props = {
  headerData: MenuNav
  uiPathSrc: string
}

const FullHeader: FC<Props> = ({ headerData, uiPathSrc }) => {
  if (!headerData) return null
  const { primaryCta, node_locale, topHatLinks, menuGroups } = headerData
  const [openMenu, setOpenMenu] = useState<boolean>(false)
  const navbarRef = useRef<any>(null)

  const externalUrl = primaryCta && 'externalUrl' in primaryCta ? primaryCta?.externalUrl : ''
  const text = primaryCta && 'text' in primaryCta ? primaryCta?.text : ''
  const internalLink = primaryCta && 'internalLink' in primaryCta ? primaryCta.internalLink : null
  const location = headerData?.location || 'custom header'
  const internalLinkSlug =
    internalLink && 'slug' in internalLink ? uiPathSrc + internalLink.slug : ''
  const btnURL = externalUrl || internalLinkSlug || null

  const handleResize = () => {
    if (window.innerWidth > 768) {
      setOpenMenu(false)
      document.body.style.overflow = 'auto'
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      {headerData?.butterBar && <ButterBar headerData={headerData} />}
      <Navbar data-cy="fullHeader" ref={navbarRef} $openMenu={openMenu}>
        <NavbarContainer $openMenu={openMenu}>
          <div className="Navbar__Mobile_Top">
            {<NavLogo uiPathSrc={uiPathSrc} langCode={node_locale || LocaleCodes.ENGLISH.code} />}
            {<NavHamburgerIcon openMenu={openMenu} setOpenMenu={setOpenMenu} />}
          </div>

          <NavLinks
            navLinks={menuGroups}
            openMenu={openMenu}
            uiPathSrc={uiPathSrc}
            location={location}
          />

          <IconLinksSection
            $openMenu={openMenu}
            $langCode={node_locale || LocaleCodes.ENGLISH.code}>
            {node_locale !== LocaleCodes.CHINESE.code ? <SearchIcon /> : null}
            {topHatLinks && <TopHatLinks headerData={headerData} />}
          </IconLinksSection>

          {btnURL && <NavButton url={btnURL} text={text || ''} />}
        </NavbarContainer>
      </Navbar>
    </>
  )
}

export default FullHeader
